import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { FeatureFlags, HashTable } from '../interfaces';
import { ApiEndpointService } from './api-endpoint.service';

@Injectable()
export class FeatureflagService {
  featureFlagsCollection: HashTable<string> = {};
  featureFlagsBehaviorSubject: BehaviorSubject<HashTable<string>> =
    new BehaviorSubject<HashTable<string>>(null);

  constructor(
    private httpService: HttpService,
    private apiEndpoint: ApiEndpointService
  ) {}

  isEnabled(
    accountKey: string,
    featureFlagPath: FeatureFlags
  ): Promise<boolean> {
    return this.httpService
      .get(this.apiEndpoint.FeatureFlagPagesUrl, undefined, {
        headers: {
          accountKey,
          featureFlagPath,
        },
      })
      .toPromise();
  }

  getFlags() {
    return this.httpService.get(this.apiEndpoint.FeatureFlagsUrl).pipe(
      tap((result: any) => {
        Object.keys(result).forEach((key: string) => {
          this.featureFlagsCollection[key] = result[key];
        });
        this.featureFlagsBehaviorSubject.next(this.featureFlagsCollection);
      })
    );
  }
}
